module.exports = __webpack_public_path__ + "static/media/profile-bg.31f90ffd.png";